// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5d8b63b7","389":"38fffcda","453":"3ec2c64b","732":"0d9a6599","977":"24a74103"}[chunkId] + ".chunk.js";
};